var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1284 39.209C33.1284 46.2653 38.869 52.0059 45.9253 52.0059C52.9816 52.0059 58.7222 46.2653 58.7222 39.209C58.7222 32.1527 52.9816 26.4121 45.9253 26.4121C38.869 26.4121 33.1284 32.1527 33.1284 39.209ZM45.9253 28.1184C52.0408 28.1184 57.016 33.0935 57.016 39.209C57.016 45.3245 52.0408 50.2996 45.9253 50.2996C39.8098 50.2996 34.8347 45.3245 34.8347 39.209C34.8347 33.0935 39.8098 28.1184 45.9253 28.1184Z",
    fill: "#867662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0244 37.6882L41.3313 40.9464L40.5705 45.5257C40.5175 45.8446 40.6491 46.1658 40.9107 46.3558C41.172 46.5458 41.5183 46.5714 41.8052 46.4228L45.9252 44.2833L50.0449 46.4228C50.3295 46.5704 50.6757 46.5474 50.9393 46.3558C51.2009 46.1658 51.3325 45.8446 51.2796 45.5257L50.5187 40.9464L53.8256 37.6882C54.0559 37.4616 54.1382 37.1244 54.0382 36.8168C53.9382 36.5095 53.6733 36.2852 53.3537 36.2369L48.7645 35.5461L46.688 31.3934C46.5437 31.1045 46.2481 30.9219 45.9252 30.9219C45.6019 30.9219 45.3067 31.1045 45.162 31.3934L43.0855 35.5461L38.4963 36.2369C38.1767 36.2849 37.9118 36.5095 37.8118 36.8168C37.7118 37.1244 37.7945 37.4616 38.0244 37.6882ZM43.7777 37.1674C44.0523 37.126 44.2896 36.9537 44.4139 36.7055L45.9252 33.6825L47.4365 36.7055C47.5608 36.9537 47.7981 37.126 48.0727 37.1674L51.4129 37.6702L49.0058 40.0413C48.8082 40.2363 48.7175 40.5152 48.7628 40.7891L49.3167 44.122L46.3181 42.5651C46.1951 42.5011 46.0602 42.4691 45.9252 42.4691C45.7902 42.4691 45.6553 42.5011 45.5319 42.5651L42.5333 44.122L43.0872 40.7891C43.1329 40.5152 43.0422 40.2363 42.8443 40.0413L40.4375 37.6702L43.7777 37.1674Z",
    fill: "#867662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7785 23.8531C46.7785 24.3243 46.3966 24.7063 45.9254 24.7063C45.4542 24.7063 45.0723 24.3243 45.0723 23.8531C45.0723 23.3819 45.4542 23 45.9254 23C46.3966 23 46.7785 23.3819 46.7785 23.8531Z",
    fill: "#867662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9045 23.5033C34.7279 25.3352 29.7158 31.794 29.7158 39.2098C29.7158 43.8157 31.6524 48.1557 35.0519 51.2293L29.9121 60.2874C29.7468 60.579 29.7675 60.9402 29.9648 61.2108C30.162 61.4818 30.4993 61.6121 30.8276 61.5437L36.6645 60.3317L38.716 66.1126C38.8273 66.4272 39.1122 66.6475 39.4448 66.6772C39.7774 66.7068 40.0963 66.5392 40.2613 66.2489L45.9252 56.2914L51.5888 66.2489C51.7415 66.5172 52.0254 66.6802 52.33 66.6802C52.355 66.6802 52.3803 66.6792 52.4053 66.6772C52.7379 66.6475 53.0228 66.4269 53.1345 66.1126L55.1856 60.3317L61.0226 61.5437C61.3505 61.6117 61.6881 61.4814 61.8853 61.2108C62.083 60.9402 62.1033 60.579 61.938 60.2874L56.7983 51.2293C60.1978 48.1557 62.1343 43.8157 62.1343 39.2098C62.1343 31.794 57.1222 25.3352 49.9459 23.5033C49.489 23.3867 49.0248 23.6623 48.9082 24.1188C48.7915 24.5754 49.0671 25.0399 49.5237 25.1566C55.9441 26.7955 60.4284 32.5744 60.4284 39.2098C60.4284 47.2855 53.8696 53.713 45.9252 53.713C37.9752 53.713 31.4221 47.2802 31.4221 39.2098C31.4221 32.5744 35.906 26.7955 42.3264 25.1566C42.783 25.0399 43.0586 24.5754 42.9423 24.1188C42.8256 23.6623 42.3614 23.3867 41.9045 23.5033ZM39.7004 63.7845L38.0238 59.06C37.8812 58.6581 37.4639 58.4232 37.0464 58.5098L32.3265 59.4899L36.3942 52.321C38.766 54.0452 41.5743 55.0956 44.4946 55.3556L39.7004 63.7845ZM54.8037 58.5098C54.3865 58.4232 53.9689 58.6581 53.8263 59.06L52.15 63.7845L47.3555 55.3556C50.2762 55.0956 53.0842 54.0452 55.4562 52.321L59.5239 59.4899L54.8037 58.5098Z",
    fill: "#867662"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_429)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 42,
    r: 41.5,
    stroke: "#867662",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_429",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_429",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.68,
    height: 43.68,
    fill: "white",
    transform: "translate(24 23)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsIcon);
export default __webpack_public_path__ + "static/media/is-icon.da3219c64a31fceb63dd42c7e285375c.svg";
export { ForwardRef as ReactComponent };